import { Confirmation } from "../components";

export const ConfirmRegistration = () => {
  return <Confirmation />;
};
